import React, { useState } from "react"
import Modal from "react-modal"

import Burger from "../svg/burger"
import { goHome } from "../../utilities/functions"
import Logo from "../svg/logo"
import Navigation from "../navigation/navigation"
import "./header.scss"
import Button from "../button/button"
import Enroll from "../enroll/enroll"

Modal.setAppElement("#___gatsby")

const Header = () => {
  const [isNavActive, setIsNavActive] = useState(false)
  const [enrollModalIsOpen, setEnrollModalIsOpen] = useState(false)

  const switchNavState = () => {
    setIsNavActive(!isNavActive)
  }
  const openEnrollModal = () => {
    setEnrollModalIsOpen(true)
  }
  const closeEnrollModal = () => {
    setEnrollModalIsOpen(false)
  }
  return (
    <header className="common-header">
      <div>
        <button
          className="common-header__to-home-button common-header__button"
          onClick={goHome}
        >
          <Logo />
        </button>
        <a href="/">L &#8217;école des langues A.Croix</a>
      </div>
      <div>
        <Button
          type=""
          text="ЗАПИСАТЬСЯ"
          handleClick={openEnrollModal}
          className="common-header__enroll-button"
        />
        {isNavActive && <Navigation />}
        <button
          className="common-header__button common-header__burger-button"
          onClick={switchNavState}
        >
          <Burger svgClass="common-header__burger" /></button>

      </div>
      <Modal
        isOpen={enrollModalIsOpen}
        onRequestClose={closeEnrollModal}
        contentLabel="Enroll"
        className="ModalQ"
        overlayClassName="Overlay"
      >
        <button className="closeModal" onClick={closeEnrollModal}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M0.720072 0.719909C0.860698 0.579459 1.05132 0.500569 1.25007 0.500569C1.44882 0.500569 1.63945 0.579459 1.78007 0.719909L7.00007 5.93991L12.2201 0.719909C12.2887 0.646222 12.3715 0.58712 12.4635 0.546128C12.5555 0.505136 12.6548 0.483095 12.7556 0.481318C12.8563 0.479541 12.9563 0.498066 13.0497 0.535787C13.1431 0.573508 13.2279 0.629652 13.2991 0.700871C13.3703 0.77209 13.4265 0.856923 13.4642 0.950312C13.5019 1.0437 13.5204 1.14373 13.5187 1.24443C13.5169 1.34513 13.4948 1.44445 13.4539 1.53645C13.4129 1.62845 13.3538 1.71125 13.2801 1.77991L8.06007 6.99991L13.2801 12.2199C13.3538 12.2886 13.4129 12.3714 13.4539 12.4634C13.4948 12.5554 13.5169 12.6547 13.5187 12.7554C13.5204 12.8561 13.5019 12.9561 13.4642 13.0495C13.4265 13.1429 13.3703 13.2277 13.2991 13.2989C13.2279 13.3702 13.1431 13.4263 13.0497 13.464C12.9563 13.5018 12.8563 13.5203 12.7556 13.5185C12.6548 13.5167 12.5555 13.4947 12.4635 13.4537C12.3715 13.4127 12.2887 13.3536 12.2201 13.2799L7.00007 8.05991L1.78007 13.2799C1.6379 13.4124 1.44985 13.4845 1.25555 13.4811C1.06125 13.4777 0.875864 13.3989 0.738451 13.2615C0.601038 13.1241 0.522326 12.9387 0.518898 12.7444C0.515469 12.5501 0.587592 12.3621 0.720072 12.2199L5.94007 6.99991L0.720072 1.77991C0.579622 1.63928 0.500732 1.44866 0.500732 1.24991C0.500732 1.05116 0.579622 0.860534 0.720072 0.719909Z"
                  fill="white" />
          </svg>
        </button>
        <Enroll closeModal={closeEnrollModal} />
      </Modal>
    </header>
  )
}

export default Header
